import {tns} from 'tiny-slider/src/tiny-slider'
var selection = document.querySelectorAll('.slider-location')
var total_wrap = selection.length
var j = 0
if (selection !== null) {
  for (var i in selection) {
    j++
    if (total_wrap >= j) {
      var id_section = selection[i].id
      var disable_carousel = document.getElementById(id_section).getAttribute('disable-toggle') == 'false' ? true : false
      var toggle_controls = document.getElementById(id_section).getAttribute('toggle-controls') == 'false' ? false : true

      var width = jQuery('body').width()
      if (toggle_controls && width > 1100 && document.getElementById(id_section + '-list') !== null) {
        document.getElementById(id_section + '-list').style.paddingRight = '85px'
      }
      const slider_2 = tns({
        container: '#' + id_section,
        navPosition: 'bottom',
        controls: toggle_controls,
        controlsText: ['', ''],
        mouseDrag: true,
        speed: 400,
        slideBy: 'page',
        swipeAngle: false,
        loop: false,
        disable: disable_carousel,
        responsive: {
          300: {
            items: 2,
            nav: true,
            navPosition: 'bottom',
          },
          650: {
            items: 3,
            nav: true,
            navPosition: 'bottom',
          },
          768: {
            items: 3,
            nav: true,
            navPosition: 'bottom',
          },
          1100: {
            slideBy: 1,
            items: 4,
            nav: false,
          },
        },
      })
    }
  }
}

// related location slider.
var selection_related = document.querySelectorAll('.related-location-slider')
var total_wrap_related = selection_related.length

var k = 0
if (selection_related !== null) {
  for (var i in selection_related) {
    k++
    if (total_wrap_related >= k) {
      var id_section = selection_related[i].id
      //var disable_toggle = document.getElementById(id_section).getAttribute('disable-toggle') == 'false' ? false : true
      //  var disable_toggle_controls = document.getElementById(id_section).getAttribute('disable-toggle-controls') == 'true' ? false : true
      const slider_3 = tns({
        container: '#' + id_section,
        navPosition: 'bottom',
        controls: false,
        controlsText: ['', ''],
        mouseDrag: true,
        speed: 400,
        slideBy: 'page',
        swipeAngle: false,
        loop: true,
        disable: true,
        responsive: {
          300: {
            disable: false,
            items: 2,
            nav: true,
            navPosition: 'bottom',
          },
          500: {
            disable: false,
            items: 3,
            nav: true,
            navPosition: 'bottom',
          },
          768: {
            disable: false,
            items: 3,
            nav: true,
            navPosition: 'bottom',
          },
          1100: {
            slideBy: 1,
            items: 4,
            nav: false,
            disable: true,
          },
        },
      })
    }
  }
}
